function scrollToHeadings() {
    document.querySelector('.fpHero__anchor').addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: document.getElementById('headings').getBoundingClientRect().top + document.documentElement.scrollTop,
            left: 0,
            behavior: 'smooth'
        });
    });
}

window.addEventListener('DOMContentLoaded', function(){
    if(document.querySelector('#body.home.logged-in')) {
        scrollToHeadings();
    }
});